import { Link } from '@tanstack/react-router';
import { BookAlert } from 'lucide-react';

import { Container } from '@/components/custom/container';
import { useDashboardContext } from '@/stores/context/dashboard-layout-context';
// import { useStore } from '@/stores';

import { IconSide } from './icon-list';

const SidebarItems = () => {
  const { toggleSidebar } = useDashboardContext();
  // const merchantAccess = useStore((state) => state.merchantAccess);
  const data = {
    access: [
      {
        group: '',
        order: 0,
        role_access: [
          {
            name: 'Mode',
            route: '/mode',
            action: ['MODE_SWITCH'],
            order: 0,
          },
        ],
      },
      // {
      //   group: 'Home',
      //   order: 1,
      //   role_access: [
      //     {
      //       name: 'Dashboard',
      //       route: '/dashboard',
      //       action: ['DASHBOARD_READ_CHART'],
      //       order: 1,
      //     },
      //   ],
      // },
      {
        group: 'Reports',
        order: 2,
        role_access: [
          {
            name: 'Disbursement',
            route: '/disbursement',
            action: null,
            order: 1,
          },
          {
            name: 'Cash Flow',
            route: '/cash-flow',
            action: ['BALANCE'],
            order: 2,
          },
          // {
          //   name: 'Transaction',
          //   route: '/transaction',
          //   action: ['TRANSACTION_DOWNLOAD_REPORT', 'TRANSACTION_READ_TABLE'],
          //   order: 3,
          // },
          // {
          //   name: 'Qris Payment',
          //   route: '/qris-payment',
          //   action: ['QRIS_DOWNLOAD_REPORT', 'QRIS_READ_TABLE'],
          //   order: 4,
          // },
          {
            name: 'Settlement',
            route: '/settlement',
            action: ['SETTLEMENT_DOWNLOAD_REPORT', 'SETTLEMENT_READ_TABLE'],
            order: 5,
          },
        ],
      },
      // {
      //   group: 'Invoices',
      //   order: 3,
      //   role_access: [
      //     {
      //       name: 'Payment Link',
      //       route: '/payment-link',
      //       action: ['PAYMENT_LINK_CREATE', 'PAYMENT_LINK_READ_TABLE'],
      //       order: 1,
      //     },
      //   ],
      // },
      {
        group: 'Accounts',
        order: 4,
        role_access: [
          {
            name: 'Merchant',
            route: '/merchant',
            action: [
              'USER_DELETE_USER',
              'USER_CREATE_NEW_USER',
              'USER_READ_PROFILE',
              'USER_UPDATE_TABLE',
              'USER_READ_TABLE',
            ],
            order: 1,
          },
        ],
      },
    ],
  };

  return (
    <Container direction="column" className="overflow-y-auto">
      {data?.access.map((item, idx) => {
        if (!item.group) return null;
        return (
          <div key={idx} className="text-gray-500">
            <div className="mt-2 px-3 py-1 text-xs leading-6 font-bold text-gray-600 first:mt-3">
              {item.group.toLocaleUpperCase()}
            </div>
            {item.role_access.map((sidebar, sidebarIdx) => {
              const IconComponent =
                IconSide.find((iconItems) => iconItems.name === sidebar.name)?.icon || BookAlert;

              if (sidebar.name === 'Mode') return null;
              return (
                <Link
                  to={sidebar.route}
                  key={sidebarIdx}
                  activeProps={{
                    className: 'text-white bg-brand-blue hover:bg-brand-blue hover:text-white',
                  }}
                  onClick={toggleSidebar}
                  className="hover:text-brand-blue flex items-center gap-4 rounded-lg px-2.5 py-3 text-sm leading-5 font-normal whitespace-nowrap hover:bg-blue-50"
                >
                  <IconComponent size={20} />
                  <div>{sidebar.name}</div>
                </Link>
              );
            })}
          </div>
        );
      })}
    </Container>
  );
};

export default SidebarItems;
